import React from 'react';
import { BeatLoader } from 'react-spinners';

const LoadingSpinner = () => {
  const spinnerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
  };

  return (
    <div style={spinnerStyle}>
      <BeatLoader color="#84d2e6" size={22} />
    </div>
  );
};

export default LoadingSpinner;
